import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    // pullNewH5: pullNewH5
  },
  // 定义状态
  state: {
    LOADING: false,//加载
    isPullNewLogin: false,
    loginInfo: null,//登录返回信息
    userInfoPullNew: null,//H5拉新赚佣
    buttondisabled: false,//异步请求时按钮的状态控制
    carrierList: null,//运营商
    allCityAscrpt: null,//所有归属地市
    cityAscrpt: null,//某个地区的归属地市
    userMenuList: null,//菜单权限
    queryCard: {//号卡订单
      create: false,
      edit: false,
      detail: false,
      list: false,
      export: false,//导出
      import: false,//活动订单导入
    },
    bookCardOrder: {//在途订单查询
      create: false,
      edit: false,
      detail: false,
      list: false,
      export: false,//导出
      import: false,//导入
    },
    queryNxBroad: {//宁夏宽带
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    querySxBroad: {//陕西宽带
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    querySxFlow: {//陕西流量查询
      create: false,
      edit: false,
      detail: false,
      list: false,
      export: false,
      import: false,
    },
    queryNxFlow: {//宁夏流量查询
      create: false,
      edit: false,
      detail: false,
      list: false,
      export: false,
      import: false,
    },
    queryHfb: {//宁夏话费宝
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    ebOrderList: {//电商列表
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    weixinCollectOrder: {
      create: false,
      delete: false,
      detail: false,
      edit: false,
      export: false,
      import: false,
      list: false,
    },
    weixinCollectAccount: {
      create: false,
      delete: false,
      detail: false,
      edit: false,
      export: false,
      import: false,
      list: false,
    },
    createSnCard: {//陕西号卡下单
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    sndxCardOrder: {//陕西电信号卡下单
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    sndxxbCardOrder: {//陕西电信号卡小白卡下单
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    createNxCard: {//宁夏号卡下单
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    createGansuCard: {//宁夏号卡下单
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    createCqCard: {//重庆号卡下单
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    createSnProduct: {//陕西套餐变更
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    createNxProduct: {//宁夏套餐变更
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    createSnBrand: {//陕西宽带办理
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    createNxBrand: {//宁夏宽带办理
      create: false,
      edit: false,
      detail: false,
      list: false
    },
    configCardDiscnt: {//号卡套餐配置
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false
    },
    configSnFlowDiscnt: {//陕西流量配置
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false
    },
    configNxFlowDiscnt: {//宁夏流量配置
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false
    },
    configNxBroadDiscnt: {//宁夏宽带套餐配置
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false
    },
    configSnBroadDiscnt: {//陕西宽带套餐配置
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false
    },
    accountMgr: {//工号配置
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false
    },
    roleMgr: {
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false
    },
    phoneMgr: {//号码池
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false
    },
    pullNewsZfblist: {//支付宝拉新
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false,
      export: false,
      import: false
    },
    pullNewtbList: {//淘宝拉新
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false,
      export: false,
      import: false
    },
    pullNewpaylist: {//打款记录
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false,
      export: false,
      import: false
    },
    pullNewUserinfo: {//注册用户
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false,
      export: false,
      import: false
    },
    addAppCredit: {//话费平台太管理-转账审核
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false,
      export: false,
      import: false
    },
    hfbOrderQuery: {//营销活动查询
      create: false,
      edit: false,
      delete: false,
      detail: false,
      list: false,
      export: false,
      import: false
    },
    cardOrderExport: false,//号卡订单导出
    cardOrderImport: false,//号卡订单导入
    takeImport: false,//号卡订单 物流导入


    // 新增按钮权限-------------
    errorOrderExport: false,//失败订单导出
    orderExport: false,
    xxlClickExport: false,
    appOrderExport: false,
    noOrderTraceExport: false,
    batchCardOrderExport: false,
    cqydCardExport: false,
    numberPoolExport: false,
    cardActExport: false,
    noOrderTraceImport: false,
    batchCardOrderImport: false,
    jiyunCardOrderTraceImport: false,


    sxFlowOrderExport: false,//陕西流量订单导出

    allFlowOrderExport: false,//所有流量订单导出（除部分陕西流量订单）

    ebOrderEdit: false,//电商订单编辑
    sysEbOrder: false,//电商订单同步
  },
  //组件回调设置
  mutations: {
    showLoading(state) {
      state.LOADING = true;
    },
    hideLoading(state) {
      state.LOADING = false;
    },
    isPullNewLogin(state, msg) {//H5 是否登录
      state.isPullNewLogin = msg;
      localStorage.isPullNewLogin = msg;
    },
    setLoginInfo(state, msg) {//H5 注册登录返回信息
      state.loginInfo = msg;
      localStorage.setItem('loginInfo', msg ? JSON.stringify(msg) : '');
    },
    setPullNewUserInfo(state, msg) {//H5 用户信息
      state.userInfoPullNew = msg;
      localStorage.setItem('userInfoPullNew', msg ? JSON.stringify(msg) : '');
    },
    setButtonDisabledState(state, msg) {
      state.buttondisabled = msg;
    },
    setCarrierList(state, msg) {//归属运营商
      state.carrierList = msg;
      sessionStorage.setItem('carrierList', msg ? JSON.stringify(msg) : '');
    },
    setAllCityAscrpt(state, msg) {//所有归属地市
      state.allCityAscrpt = msg;
      sessionStorage.setItem('allCityAscrpt', msg ? JSON.stringify(msg) : '');
    },
    setCityAscrpt(state, msg) {//归属地市
      state.cityAscrpt = msg;
      sessionStorage.setItem('cityAscrpt', msg ? JSON.stringify(msg) : '');
    },
    setUserMenuList(state, msg) {//用户菜单权限
      state.userMenuList = msg;
      sessionStorage.setItem('userMenuList', msg ? JSON.stringify(msg) : '');
    },
    /**操作权限 start */
    cardOrderExport(state, msg) {//号卡订单导出
      state.cardOrderExport = msg;
      sessionStorage.setItem('cardOrderExport', msg ? JSON.stringify(msg) : '');
    },
    cardOrderImport(state, msg) {//号卡活动订单导入
      state.cardOrderImport = msg;
      sessionStorage.setItem('cardOrderImport', msg ? JSON.stringify(msg) : '');
    },
    takeImport(state, msg) {//号卡物流导入
      state.takeImport = msg;
      sessionStorage.setItem('takeImport', msg ? JSON.stringify(msg) : '');
    },
    // 新增按钮权限-------------
    errorOrderExport(state, msg) {//失败订单导出
      state.errorOrderExport = msg;
      sessionStorage.setItem('errorOrderExport', msg ? JSON.stringify(msg) : '');
    },
    orderExport(state, msg) {
      state.orderExport = msg;
      sessionStorage.setItem('orderExport', msg ? JSON.stringify(msg) : '');
    },
    xxlClickExport(state, msg) {
      state.xxlClickExport = msg;
      sessionStorage.setItem('xxlClickExport', msg ? JSON.stringify(msg) : '');
    },
    appOrderExport(state, msg) {
      state.appOrderExport = msg;
      sessionStorage.setItem('appOrderExport', msg ? JSON.stringify(msg) : '');
    },
    noOrderTraceExport(state, msg) {
      state.noOrderTraceExport = msg;
      sessionStorage.setItem('noOrderTraceExport', msg ? JSON.stringify(msg) : '');
    },
    batchCardOrderExport(state, msg) {
      state.batchCardOrderExport = msg;
      sessionStorage.setItem('batchCardOrderExport', msg ? JSON.stringify(msg) : '');
    },
    cqydCardExport(state, msg) {
      state.cqydCardExport = msg;
      sessionStorage.setItem('cqydCardExport', msg ? JSON.stringify(msg) : '');
    },
    numberPoolExport(state, msg) {
      state.numberPoolExport = msg;
      sessionStorage.setItem('numberPoolExport', msg ? JSON.stringify(msg) : '');
    },
    cardActExport(state, msg) {
      state.cardActExport = msg;
      sessionStorage.setItem('cardActExport', msg ? JSON.stringify(msg) : '');
    },
    noOrderTraceImport(state, msg) {
      state.noOrderTraceImport = msg;
      sessionStorage.setItem('noOrderTraceImport', msg ? JSON.stringify(msg) : '');
    },
    batchCardOrderImport(state, msg) {
      state.batchCardOrderImport = msg;
      sessionStorage.setItem('batchCardOrderImport', msg ? JSON.stringify(msg) : '');
    },
    jiyunCardOrderTraceImport(state, msg) {
      state.jiyunCardOrderTraceImport = msg;
      sessionStorage.setItem('jiyunCardOrderTraceImport', msg ? JSON.stringify(msg) : '');
    },


    sxFlowOrderExport(state, msg) {//陕西流量订单导出
      state.sxFlowOrderExport = msg;
      sessionStorage.setItem('sxFlowOrderExport', msg ? JSON.stringify(msg) : '');
    },
    allFlowOrderExport(state, msg) {//所有流量订单导出（除部分陕西流量订单）
      state.allFlowOrderExport = msg;
      sessionStorage.setItem('allFlowOrderExport', msg ? JSON.stringify(msg) : '');
    },
    ebOrderEdit(state, msg) {//电商订单编辑
      state.ebOrderEdit = msg;
      sessionStorage.setItem('ebOrderEdit', msg ? JSON.stringify(msg) : '');
    },
    sysEbOrder(state, msg) {//电商订单同步
      state.sysEbOrder = msg;
      sessionStorage.setItem('sysEbOrder', msg ? JSON.stringify(msg) : '');
    },
    /**操作权限 end */
    queryCard(state, msg) {//订单查询
      state.queryCard.create = msg.create;
      state.queryCard.edit = msg.edit;
      state.queryCard.detail = msg.detail;
      state.queryCard.list = msg.list;
      state.queryCard.export = msg.export;
      state.queryCard.import = msg.import;
      sessionStorage.setItem('queryCard', msg ? JSON.stringify(msg) : '');
    },
    bookCardOrder(state, msg) {//在途订单查询
      state.bookCardOrder.create = msg.create;
      state.bookCardOrder.edit = msg.edit;
      state.bookCardOrder.detail = msg.detail;
      state.bookCardOrder.list = msg.list;
      state.bookCardOrder.export = msg.export;
      state.bookCardOrder.import = msg.import;
      sessionStorage.setItem('bookCardOrder', msg ? JSON.stringify(msg) : '');
    },
    queryNxBroad(state, msg) {//宁夏宽带订单
      state.queryNxBroad.create = msg.create;
      state.queryNxBroad.edit = msg.edit;
      state.queryNxBroad.detail = msg.detail;
      state.queryNxBroad.list = msg.list;
      sessionStorage.setItem('queryNxBroad', msg ? JSON.stringify(msg) : '');
    },
    querySxBroad(state, msg) {//陕西宽带订单
      state.querySxBroad.create = msg.create;
      state.querySxBroad.edit = msg.edit;
      state.querySxBroad.detail = msg.detail;
      state.querySxBroad.list = msg.list;
      sessionStorage.setItem('querySxBroad', msg ? JSON.stringify(msg) : '');
    },
    querySxFlow(state, msg) {//陕西流量订单
      state.querySxFlow.create = msg.create;
      state.querySxFlow.edit = msg.edit;
      state.querySxFlow.detail = msg.detail;
      state.querySxFlow.list = msg.list;
      state.querySxFlow.export = msg.export;
      state.querySxFlow.import = msg.import;
      sessionStorage.setItem('querySxFlow', msg ? JSON.stringify(msg) : '');
    },
    queryNxFlow(state, msg) {//宁夏流量订单
      state.queryNxFlow.create = msg.create;
      state.queryNxFlow.edit = msg.edit;
      state.queryNxFlow.detail = msg.detail;
      state.queryNxFlow.list = msg.list;
      state.queryNxFlow.export = msg.export;
      state.queryNxFlow.import = msg.import;
      sessionStorage.setItem('queryNxFlow', msg ? JSON.stringify(msg) : '');
    },
    queryHfb(state, msg) {//宁夏话费宝
      state.queryHfb.create = msg.create;
      state.queryHfb.edit = msg.edit;
      state.queryHfb.detail = msg.detail;
      state.queryHfb.list = msg.list;
      sessionStorage.setItem('queryHfb', msg ? JSON.stringify(msg) : '');
    },
    ebOrderList(state, msg) {//电商订单
      state.ebOrderList.create = msg.create;
      state.ebOrderList.edit = msg.edit;
      state.ebOrderList.detail = msg.detail;
      state.ebOrderList.list = msg.list;
      sessionStorage.setItem('ebOrderList', msg ? JSON.stringify(msg) : '');
    },
    weixinCollectOrder(state, msg) {//号卡推广订单
      state.weixinCollectOrder.create = msg.create;
      state.weixinCollectOrder.edit = msg.edit;
      state.weixinCollectOrder.detail = msg.detail;
      state.weixinCollectOrder.list = msg.list;
      state.weixinCollectOrder.export = msg.export;
      state.weixinCollectOrder.import = msg.import;
      sessionStorage.setItem('weixinCollectOrder', msg ? JSON.stringify(msg) : '');
    },
    weixinCollectAccount(state, msg) {//号卡推广账号
      state.weixinCollectAccount.create = msg.create;
      state.weixinCollectAccount.edit = msg.edit;
      state.weixinCollectAccount.detail = msg.detail;
      state.weixinCollectAccount.list = msg.list;
      state.weixinCollectAccount.export = msg.export;
      state.weixinCollectAccount.import = msg.import;
      sessionStorage.setItem('weixinCollectAccount', msg ? JSON.stringify(msg) : '');
    },
    createSnCard(state, msg) {
      state.createSnCard.create = msg.create;
      state.createSnCard.edit = msg.edit;
      state.createSnCard.detail = msg.detail;
      state.createSnCard.list = msg.list;
      sessionStorage.setItem('createSnCard', msg ? JSON.stringify(msg) : '');
    },
    sndxCardOrder(state, msg) {
      state.sndxCardOrder.create = msg.create;
      state.sndxCardOrder.edit = msg.edit;
      state.sndxCardOrder.detail = msg.detail;
      state.sndxCardOrder.list = msg.list;
      sessionStorage.setItem('sndxCardOrder', msg ? JSON.stringify(msg) : '');
    },
    createNxCard(state, msg) {
      state.createNxCard.create = msg.create;
      state.createNxCard.edit = msg.edit;
      state.createNxCard.detail = msg.detail;
      state.createNxCard.list = msg.list;
      sessionStorage.setItem('createNxCard', msg ? JSON.stringify(msg) : '');
    },
    createGansuCard(state, msg) {
      state.createGansuCard.create = msg.create;
      state.createGansuCard.edit = msg.edit;
      state.createGansuCard.detail = msg.detail;
      state.createGansuCard.list = msg.list;
      sessionStorage.setItem('createGansuCard', msg ? JSON.stringify(msg) : '');
    },
    createCqCard(state, msg) {
      state.createCqCard.create = msg.create;
      state.createCqCard.edit = msg.edit;
      state.createCqCard.detail = msg.detail;
      state.createCqCard.list = msg.list;
      sessionStorage.setItem('createCqCard', msg ? JSON.stringify(msg) : '');
    },
    createSnProduct(state, msg) {
      state.createSnProduct.create = msg.create;
      state.createSnProduct.edit = msg.edit;
      state.createSnProduct.detail = msg.detail;
      state.createSnProduct.list = msg.list;
      sessionStorage.setItem('createSnProduct', msg ? JSON.stringify(msg) : '');
    },
    createNxProduct(state, msg) {
      state.createNxProduct.create = msg.create;
      state.createNxProduct.edit = msg.edit;
      state.createNxProduct.detail = msg.detail;
      state.createNxProduct.list = msg.list;
      sessionStorage.setItem('createNxProduct', msg ? JSON.stringify(msg) : '');
    },
    createSnBrand(state, msg) {
      state.createSnBrand.create = msg.create;
      state.createSnBrand.edit = msg.edit;
      state.createSnBrand.detail = msg.detail;
      state.createSnBrand.list = msg.list;
      sessionStorage.setItem('createSnBrand', msg ? JSON.stringify(msg) : '');
    },
    createNxBrand(state, msg) {
      state.createNxBrand.create = msg.create;
      state.createNxBrand.edit = msg.edit;
      state.createNxBrand.detail = msg.detail;
      state.createNxBrand.list = msg.list;
      sessionStorage.setItem('createNxBrand', msg ? JSON.stringify(msg) : '');
    },
    configCardDiscnt(state, msg) {
      state.configCardDiscnt.create = msg.create;
      state.configCardDiscnt.edit = msg.edit;
      state.configCardDiscnt.delete = msg.delete;
      state.configCardDiscnt.detail = msg.detail;
      state.configCardDiscnt.list = msg.list;
      sessionStorage.setItem('configCardDiscnt', msg ? JSON.stringify(msg) : '');
    },
    configSnFlowDiscnt(state, msg) {
      state.configSnFlowDiscnt.create = msg.create;
      state.configSnFlowDiscnt.edit = msg.edit;
      state.configSnFlowDiscnt.detail = msg.detail;
      state.configSnFlowDiscnt.list = msg.list;
      sessionStorage.setItem('configSnFlowDiscnt', msg ? JSON.stringify(msg) : '');
    },
    configNxFlowDiscnt(state, msg) {
      state.configNxFlowDiscnt.create = msg.create;
      state.configNxFlowDiscnt.edit = msg.edit;
      state.configNxFlowDiscnt.detail = msg.detail;
      state.configNxFlowDiscnt.list = msg.list;
      sessionStorage.setItem('configNxFlowDiscnt', msg ? JSON.stringify(msg) : '');
    },
    configNxBroadDiscnt(state, msg) {
      state.configNxBroadDiscnt.create = msg.create;
      state.configNxBroadDiscnt.edit = msg.edit;
      state.configNxBroadDiscnt.detail = msg.detail;
      state.configNxBroadDiscnt.list = msg.list;
      sessionStorage.setItem('configNxBroadDiscnt', msg ? JSON.stringify(msg) : '');
    },
    configSnBroadDiscnt(state, msg) {
      state.configSnBroadDiscnt.create = msg.create;
      state.configSnBroadDiscnt.edit = msg.edit;
      state.configSnBroadDiscnt.detail = msg.detail;
      state.configSnBroadDiscnt.list = msg.list;
      sessionStorage.setItem('configSnBroadDiscnt', msg ? JSON.stringify(msg) : '');
    },
    phoneMgr(state, msg) {
      state.phoneMgr.create = msg.create;
      state.phoneMgr.edit = msg.edit;
      state.phoneMgr.detail = msg.detail;
      state.phoneMgr.list = msg.list;
      sessionStorage.setItem('phoneMgr', msg ? JSON.stringify(msg) : '');
    },
    accountMgr(state, msg) {
      state.accountMgr.create = msg.create;
      state.accountMgr.edit = msg.edit;
      state.accountMgr.detail = msg.detail;
      state.accountMgr.list = msg.list;
      sessionStorage.setItem('accountMgr', msg ? JSON.stringify(msg) : '');
    },
    roleMgr(state, msg) {
      state.roleMgr.create = msg.create;
      state.roleMgr.edit = msg.edit;
      state.roleMgr.detail = msg.detail;
      state.roleMgr.list = msg.list;
      sessionStorage.setItem('roleMgr', msg ? JSON.stringify(msg) : '');
    },
    addAppCredit(state, msg) {//转账审核
      state.addAppCredit.create = msg.create;
      state.addAppCredit.edit = msg.edit;
      state.addAppCredit.detail = msg.detail;
      state.addAppCredit.list = msg.list;
      sessionStorage.setItem('addAppCredit', msg ? JSON.stringify(msg) : '');
    },
    hfbOrderQuery(state, msg) {
      state.hfbOrderQuery.create = msg.create;
      state.hfbOrderQuery.edit = msg.edit;
      state.hfbOrderQuery.detail = msg.detail;
      state.hfbOrderQuery.list = msg.list;
      sessionStorage.setItem('hfbOrderQuery', msg ? JSON.stringify(msg) : '');
    },
    pullNewsZfblist(state, msg) {//支付宝拉新
      state.pullNewsZfblist = msg;
      sessionStorage.setItem('pullNewsZfblist', msg ? JSON.stringify(msg) : '');
    },
    pullNewtbList(state, msg) {//淘宝拉新
      state.pullNewtbList = msg;
      sessionStorage.setItem('pullNewtbList', msg ? JSON.stringify(msg) : '');
    },
    pullNewpaylist(state, msg) {//打款记录
      state.pullNewpaylist = msg;
      sessionStorage.setItem('pullNewpaylist', msg ? JSON.stringify(msg) : '');
    },
    pullNewUserinfo(state, msg) {//注册用户
      state.pullNewUserinfo = msg;
      sessionStorage.setItem('pullNewUserinfo', msg ? JSON.stringify(msg) : '');
    },
  },
})
/**
 * H5拉新赚佣
 */
const pullNewH5 = {
  state: {
    isLogin: false,
    userInfo: null
  },
  mutations: {
    isLogin(state, msg) {
      state.isLogin = msg;
      sessionStorage.isLogin = msg;
    },
    setUserInfo(state, msg) {
      state.userInfo = msg;
      sessionStorage.setItem('userInfo', msg ? JSON.stringify(msg) : '');
    }
  }
}
export default store


// WEBPACK FOOTER //
// ./src/store/store.js